export const REQUEST_DELIVERY_DATA = 'REQUEST_DELIVERY_DATA'
export const REQUEST_DELIVERY_UNSUBSCRIPTION_DATA = 'REQUEST_DELIVERY_UNSUBSCRIPTION_DATA'
export const SET_DELIVERY_DATA = 'SET_DELIVERY_DATA'
export const SET_DELIVERY_COUPON = 'SET_DELIVERY_COUPON'
export const SET_DELIVERY_AMOUNT = 'SET_DELIVERY_AMOUNT'
